import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { v4 as uuidv4 } from "uuid";

// Fires PageView on every route change:
//   - GA4 (unchanged)
//   - Meta Pixel (browser) + Meta CAPI (server) sharing ONE event_id, so Meta
//     de-duplicates them. This lifts CAPI event coverage (the Events Manager
//     "improve coverage / dedup" diagnostic) WITHOUT double-counting.
// On first load the browser PageView is already sent by the bounce-safe 1x1
// image beacon in index.html (tagged window.__ayvvaPVID); we skip the fbq call
// once and reuse that id for the CAPI call so the two dedupe.
const TrackPageView = () => {
  const location = useLocation();
  const firstRun = useRef(true);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });

    const isFirst = firstRun.current;
    firstRun.current = false;

    const eventId =
      isFirst && typeof window !== "undefined" && window.__ayvvaPVID
        ? window.__ayvvaPVID
        : uuidv4();

    // Browser PageView: skip on first load (beacon already sent it); fire on
    // later SPA navigations so client-side coverage stays complete.
    if (!isFirst && typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "PageView", {}, { eventID: eventId });
    }

    // Server PageView (CAPI), deduped via the shared event_id.
    try {
      fetch(`${process.env.REACT_APP_BASE_URL}/cart/meta-event.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          event_name: "PageView",
          event_id: eventId,
          event_source_url: window.location.href,
        }),
      }).catch(() => {});
    } catch (e) {}
  }, [location]);

  return null;
};

export default TrackPageView;
